<template>
  <LayoutAdmin>
    <div class="main-content">
      <section class="section">
        <div class="section-header">
          <h1>Kelola Menu</h1>
        </div>

        <div class="section-body">
          <div class="row">
            <div
              v-for="e in menuUmkm"
              :key="e.id_menu_umkm"
              class="col-md-3"
            >
              <div class="card">
                <img v-if="!e.foto" class="card-img-top" :src="require('./../../assets/stisla/img/news/img01.jpg')">
                <img v-else class="card-img-top" :src="$store.getters.getBaseUrl + '/api/file/' + e.foto">
                <div class="card-body">
                  <h5 class="card-title">{{ e.nama_menu }}</h5>
                  <p class="card-text text-right">
                    Rp {{ e.harga.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") }}
                  </p>
                  <p class="text-right">
                    <button
                      class="btn btn-primary m-1"
                      @click="edit(e)"
                    >
                      <i class="fa fa-pencil-alt" />
                    </button>
                    <button
                      class="btn btn-danger m-1"
                      @click="hapus(e)"
                    >
                      <i class="fa fa-trash" />
                    </button>
                    <button
                      :title="(e.is_ready === 1) ? 'Set Tidak Tersedia' : 'Set Tersedia'"
                      class="btn m-1"
                      :class="(e.is_ready === 1) ? 'btn-warning' : 'btn-primary'"
                      @click="statusReady(e)"
                    >
                      <i class="fa" :class="(e.is_ready === 1) ? 'fa-times' : 'fa-check'" />
                    </button>
                  </p>
                </div>
              </div>
            </div>
            <!-- tambah -->
            <div class="col-md-3">
              <div
                class="card"
                style="cursor:pointer"
                :title="'Tambah menu'"
                @click="tambah"
              >
                <div class="card-body p-0">
                  <div style="height:202px;padding-top:52px;width:100%;text-align:center">
                    <i
                      class="fa fa-plus mb-3"
                      style="font-size: 2rem;color: rgba(0,0,0,.2);"
                    /><br>
                    <b>Tambah Menu</b>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>

    <b-modal
      id="modal-menu"
      :title="(aksi === 'tambah') ? 'Tambah Menu' : 'Edit Menu'"
      size="lg"
      hide-footer
    >
      <div>
        <div
          v-if="aksi === 'edit'"
        >
          <input id="editFoto" type="checkbox" v-model="editFoto" class="pr-2">
          <label for="editFoto" class="pl-2">Edit Foto</label>
        </div>
        <ImageCropperMenu
          v-if="editFoto"
          @saveImage="saveImage"
        />
        <div class="row">
          <div class="col-md-8">
            <div class="form-group">
              <label for="nama_menu">Nama Menu</label>
              <input
                id="nama_menu"
                type="text"
                class="form-control" 
                name="text"
                required
                v-model="form.nama_menu"
              >
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label for="harga">Harga</label>
              <input
                id="harga"
                type="number"
                class="form-control text-right" 
                required
                v-model="form.harga"
              >
            </div>
          </div>
        </div>
      </div>
      <div class="text-right">
        <b-button
          id="btnSubmitMenu"
          class="mx-1"
          type="submit"
          variant="primary"
          @click="submitMenu"
        >
          {{ (aksi === 'tambah') ? 'Tambah' : 'Edit' }}
        </b-button>
        <b-button
          type="button"
          class="mx-1"
          @click="$bvModal.hide('modal-menu')"
        >
          Batal
        </b-button>
      </div>
    </b-modal>
  </LayoutAdmin>
</template>

<style scoped>

</style>

<script>
import LayoutAdmin from './../layouts/Admin.vue'
import swal from 'sweetalert'
import ImageCropperMenu from '../../components/global/ImageCropperMenu.vue'

export default {
	name: 'App',
	computed: {
		profile(){
			return this.$store.getters.getUserProfile
		},
    menuUmkm() {
      return this.$store.getters.getMenuUmkm
    }
	},
	components: {
		LayoutAdmin, ImageCropperMenu
	},
  data () {
    return {
      aksi: 'none',

      idMenuUmkmShow: 0,
      form: {
        nama_menu: '',
        harga: 0,
        id_jenis_menu_umkm: 0,
        foto: null
      },
      editFoto: false
    }
  },
	mounted(){
		document.querySelector('title').innerHTML = this.$store.getters.getAppName + ' | Menu'
    if (this.menuUmkm.length === 0) {
      this.loadMenuUmkm()
    }
	},
  methods: {
    loadMenuUmkm(){
      this.$store.dispatch('fetchMenuUmkm').then((res) => {
        if (res.data.status) {
          this.$store.commit('SET_MENU_UMKM', res.data.data)
        } else {
          swal({
            title: "Gagal",
            text: res.data.message,
            icon: "error",
            buttons: "Ok"
          })
        }
      })
        .catch(() => {
          swal({
            title: "Gagal",
            text: "Ada kesalahan teknis. Harap coba lagi nanti",
            icon: "error",
            buttons: "Ok"
          })
        })
    },
    tambah () {
      this.aksi = 'tambah'
      this.idMenuUmkmShow = 0
      this.editFoto = true
      this.$bvModal.show('modal-menu')
    },
    edit (row) {
      this.aksi = 'edit'
      this.form.nama_menu = row.nama_menu
      this.form.harga = row.harga
      this.idMenuUmkmShow = row.id_menu_umkm
      this.editFoto = false
      this.$bvModal.show('modal-menu')
    },
    hapus (row) {
      swal({
        title: "Konfirmasi",
        text: `Yakin ingin menghapus menu ${row.nama_menu}?`,
        icon: "warning",
        buttons: {
          cancel: "Batal",
          ok: {
            text: "Yakin, hapus menu",
            value: "ok",
          },
        }
      }).then(val => {
        if (val === 'ok') {
          this.$store.dispatch('destroyMenuUmkm', row.id_menu_umkm).then((res) => {
            if (res.data.status) {
              swal({
                title: "Berhasil",
                text: res.data.message,
                icon: "success",
                buttons: "Ok"
              })
              this.loadMenuUmkm()
            } else {
              swal({
                title: "Gagal",
                text: res.data.message,
                icon: "error",
                buttons: "Ok"
              })
            }
          })
            .catch(() => {
              swal({
                title: "Gagal",
                text: "Ada kesalahan teknis. Harap coba lagi nanti.",
                icon: "error",
                buttons: "Ok"
              })
            })
        }
      })
    },
    saveImage(fileImg){
      this.form.foto = fileImg
    },
    submitMenu () {
      if (this.aksi === 'tambah') {
        if (!this.form.foto) {
          swal({
            title: "Kesalahan",
            text: "Pilih foto lalu klik set foto",
            icon: "error",
            buttons: "Ok"
          })
          return false
        }
      }
      if (this.aksi === 'edit' && this.editFoto) {
        if (!this.form.foto) {
          swal({
            title: "Kesalahan",
            text: "Pilih foto lalu klik set foto",
            icon: "error",
            buttons: "Ok"
          })
          return false
        }
      }
      if (this.form.nama_menu === '') {
        swal({
          title: "Kesalahan",
          text: "Masukkan nama menu",
          icon: "error",
          buttons: "Ok"
        })
        return false
      }
      if (this.form.harga === '' || this.form.harga === 0) {
        swal({
          title: "Kesalahan",
          text: "Masukkan harga",
          icon: "error",
          buttons: "Ok"
        })
        return false
      }
      const form = new FormData()
      form.append('nama_menu', this.form.nama_menu)
      form.append('harga', this.form.harga)
      if (this.aksi === 'tambah') {
        form.append('foto', this.form.foto, 'image.png')
      } else if (this.aksi === 'edit' && this.editFoto) {
        form.append('foto', this.form.foto, 'image.png')
      }

      let dispatch = ''
      let payload = null

      if (this.aksi === 'tambah') {
        dispatch = 'storeMenuUmkm'
        payload = form
      } else if (this.aksi === 'edit') {
        dispatch = 'updateMenuUmkm'
        payload = {
          id: this.idMenuUmkmShow,
          form: form
        }
      }

      this.$store.dispatch(dispatch, payload).then((res) => {
        if(res.data.status){
          this.$bvModal.hide('modal-menu')
          this.loadMenuUmkm()
          swal({
            title: "Berhasil",
            text: res.data.message,
            icon: "success",
            buttons: "Ok"
          })
        } else {
          swal({
            title: "Gagal",
            text: res.data.message,
            icon: "error",
            buttons: "Ok"
          })
        }
      })
        .catch(() => {
          swal({
            title: "Gagal",
            text: "Ada kesalahan teknis. Harap coba lagi nanti.",
            icon: "error",
            buttons: "Ok"
          })
        })

    },
    statusReady (e) {
      const formData = new FormData()
      formData.append('is_ready', (e.is_ready === 1) ? 0 : 1)
      const payload = {
        id: e.id_menu_umkm,
        form: formData
      }
      this.$store.dispatch('updateStatusMenuUmkm', payload).then((res) => {
        if(res.data.status){
          this.loadMenuUmkm()
          swal({
            title: "Berhasil",
            text: res.data.message,
            icon: "success",
            buttons: "Ok"
          })
        } else {
          swal({
            title: "Gagal",
            text: res.data.message,
            icon: "error",
            buttons: "Ok"
          })
        }
      })
        .catch(() => {
          swal({
            title: "Gagal",
            text: "Ada kesalahan teknis. Harap coba lagi nanti.",
            icon: "error",
            buttons: "Ok"
          })
        })
    }
  }
}
</script>

<style>

</style>
